/**
 * Operations that can trigger file access notifications
 * (owner and recipients notification settings).
 */
export enum FileAccessNotificationSettingOperationEnum {
  Download = 'download',
  Open = 'open',
  Edit = 'edit',
  Delete = 'delete',
  Rename = 'rename',
  Add = 'add',
  Move = 'move',
  Copy = 'copy',
}
